import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

function MileageSignupEligibilityBottomSheetKr() {
  const {t} = useInferableTranslation();
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={300}>
      <div className="bottom_sheet">
        <div className="bottom_sheet_header">
          <h2
            className="bottom_sheet_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T30201')}
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label={t('T10017')}
            onClick={() => window.bottomSheetClose(null)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">{t('T30202')}</strong>
            <div
              className="bottom_sheet_container"
              style={{whiteSpace: 'pre-wrap'}}
            >
              <p className="bottom_sheet_notice">{t('T40081')}</p>
              <ul className="bottom_sheet_list">
                <li className="bottom_sheet_item text_bold">{t('T40082')}</li>
                <li className="bottom_sheet_item text_bold">{t('T40083')}</li>
                <li className="bottom_sheet_item text_bold">{t('T40084')}</li>
              </ul>
            </div>
          </div>

          <div className="bottom_sheet_footer bottom_sheet_footer_complex">
            <button
              type="button"
              className="btn btn_large btn_outline"
              onClick={() => window.bottomSheetClose(false)}
            >
              {t('T10017')}
            </button>

            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => window.bottomSheetClose(true)}
            >
              {t('T10114')}
            </button>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default MileageSignupEligibilityBottomSheetKr;
